"use strict";Object.defineProperty(exports,"__esModule",{value:!0});exports.default=(e,s=1)=>{const t=e.substr(1,2),r=e.substr(3,2),u=e.substr(5,2);return`rgba(${parseInt(t,16)},${parseInt(r,16)},${parseInt(u,16)},${s})`};



//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/calendars/~/@vds-core/utilities/cjs/components/JavaScriptStyleHelpers/hexToRgba.js
// module id = 898
// module chunks = 0